<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion nombreGestion="Separatas" />
  <FormSeparata/>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormSeparata from '../components/FormSeparata.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormSeparata },
  name: 'GesSeparatas'
}
</script>
